import theme from "@/theme";

export const styles = {
  rightBlock: {
    maxWidth: "364px",
    height: "48px",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "visible",
    "@media (max-width: 600px)": {
      display: "none",
    },
  },

  searchField: (focused: boolean) => ({
    maxWidth: "300px",
    height: "42px",
    borderRadius: "33px",
    backgroundColor: focused ? "#FFFFFF" : theme.palette.custom.blueGray100,
    transition: "all 0.2s ease",
    border: focused ? `1px solid ${theme.palette.custom.mainBlue}` : "none",
    "& .MuiOutlinedInput-root": {
      height: "100%",
      padding: "0 10px",
      borderRadius: "12px",
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: 0,
      fontWeight: 500,
      fontSize: "14px",
      caretColor: theme.palette.custom.mainBlue,
    },
  }),

  searchFieldInput: {
    fontSize: "14px",
    width: "300px",
    height: "42px",
    flex: 1,
    paddingLeft: "12px",
  },

  notificationButton: {
    padding: 0,
    color: "text.secondary",
  },

  searchResultsWrapper: {
    position: "absolute",
    zIndex: 9999,
    width: "300px",
    maxHeight: "70vh",
    minHeight: "325px",
    top: "48px",
    borderRadius: "8px",
    padding: "8px 10px",
    backgroundColor: "#FFFFFF !important",
    boxShadow: "0px 0px 16px 0px #0000001A",
    overflowY: "auto",
    overflowX: "hidden",
  },

  searchResultItem: (bgColor: string) => ({
    width: "234px",
    minHeight: "58px",
    padding: "12px 8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "4px",
    borderBottom: "1px solid #F4F5F6",
    cursor: "pointer",
    backgroundColor: bgColor,
    "&:hover": {
      backgroundColor: "#F0F3F8",
    },
    "&:last-child": {
      borderBottom: "none",
    },
  }),

  searchResultSecondaryTextHighlighted: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "14px",
    color: "#D0021B",
    textAlign: "left",
  },

  searchResultPrimaryText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "16px",
    color: "#2A2D31",
    textAlign: "left",
  },

  searchResultSecondaryText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "14px",
    color: "#7D8690",
    textAlign: "left",
  },
};
